import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-subnavegacion',
  templateUrl: './subnavegacion.component.html' // Enlace a tu HTML externo
})
export class Subnavegacion {
  @Input() opcion1: string = '';
  @Input() opcion2: string = '';
}